import React from "react";
import SoloConnectFooter from "../components/shared/SoloConnectFooter";
import SoloConnectMobileFooter from "../components/shared/SoloConnectMobileFooter";
import  Newnabar  from "../components/shared/Newnabar";
import  Contactus   from "../components/contact-us/Contactus";
import  ContactCards   from "../components/contact-us/ContactCards";
import  MessageForm   from "../components/contact-us/MessageForm";
import  ContactSupport   from "../components/contact-us/ContactSupport";
import  SocialSection   from "../components/contact-us/SocialSection";
import SEO from "../components/shared/SEO";

export default function ContactUs() {
  return (
    <div className="">
      <SEO
        title="Contact Us | SoloConnect - Get in Touch with Our Team"
        description="Have questions or need assistance? Reach out to the SoloConnect support team. We're here to help solo travelers connect and explore."
        keywords="contact solo travel support, helpline, contact number, query support, feedback"
      />
      <div
        className="   "
      >
        <Newnabar/>
      </div>

      <Contactus/>
      <ContactCards/>
      <MessageForm/>
      <ContactSupport/>
      <SocialSection/>

      <div className="hidden md:block" data-aos="fade-up">
        <SoloConnectFooter />
      </div>

      <div className="block md:hidden" data-aos="fade-up">
        <SoloConnectMobileFooter />
      </div>
    </div>
  );
}
